// src/components/UsersHeader.jsx

import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../Common/ActionButton';
import './UsersHeader.css';
import { useTranslation } from 'react-i18next'; // Import the i18n hook
import { useLanguageSettings } from '../Common/LanguageSettingsContext'; // Import LanguageSettings hook
import { useColorSettings } from '../Common/ColorSettingsContext'; // Import ColorSettings hook
import Spinner from '../Common/Spinner'; // Import Spinner component

const UsersHeader = ({ onAddUser, isMobile }) => {
  const { t } = useTranslation(); // Initialize the i18n translation hook

  // Consume LanguageSettings and ColorSettings contexts
  const { language, updateLanguage, loading: languageLoading } = useLanguageSettings();
  const { appSettings, loading: colorLoading } = useColorSettings();

  // Combine loading states
  if (colorLoading || languageLoading) {
    return (
      <div className="users-table-header">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="users-table-header">
      <h2>{t('usersHeader.title')}</h2>
      <ActionButton
        onClick={onAddUser}
        text=""
        label={t('usersHeader.addUser')}
        icon="faPlus"
        isMobile={isMobile}
        colorType="primary"
        ariaLabel={t('usersHeader.addUserAria')}
      />
    </div>
  );
};

UsersHeader.propTypes = {
  onAddUser: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default UsersHeader;
